import React from 'react';
import TpClientPaymentItem from '../../../Domain/TpClientPaymentItem';
import TpClientPaymentService from '../../../Services/tpClientPaymentService';
import ShowEntityData from '../../../Elements/ShowEntityData';

export default class TpClientPaymentDetailsInfoTab extends React.Component {
  static defaultProps = {
    tpClientPaymentId: 0,
  };

  constructor(props) {
    super(props);
    
    this.state = {
      tpClientPaymentId: props.tpClientPaymentId,
    };
  }

  render() {
    return (
      <ShowEntityData
        itemId={this.state.tpClientPaymentId}
        type={TpClientPaymentItem}
        serviceGetByIdFunction={TpClientPaymentService.GetByPaymentById}
      />
    );
  }
}
